import React from 'react';
import '../template-file-css/document-file-template.css';


export const RPBS_ClientConsentForm = ({
    itemsRef,
    showErrorFor,
}) => {

    return (
        <form id='RPBS_ClientConsentForm' className='file-pdf-document'>
            <div className='file-template'>
            <h3>Client Consent Form</h3>
<h4>Client Information</h4>
<table>
    <tr>
        <td className='w-250'><span className='eleHeader'>Last Name:</span>
            <input type='text' id='txtLastName' name='txtLastName' className='add-only' /></td>
        <td className='w-250'><span className='eleHeader'>First Name:</span>
            <input type='text' id='txtFirstName' name='txtFirstName' className='add-only' /></td>
        <td className='w-250'><span className='eleHeader'>Middle Name:</span>
            <input type='text' id='txtMiddleName' name='txtMiddleName' className='add-only' /></td>
    </tr>
    <tr>
        <td className='w-250'><span className='eleHeader'>Date of Birth:</span>
            <input type='date' id='txtDateBirth' name='txtDateBirth' className='add-only'/></td>
        <td className='w-250'><span className='eleHeader'>SS#:</span>
            <input type='text' id='txtLastNameSS' name='txtLastNameSS' className='add-only' /></td>
        <td className='w-250'><span className='eleHeader'>Insurance#:</span>
            <input type='text' id='txtInsurance' name='txtInsurance' className='add-only' /></td>
    </tr>
</table>
<h4>Legal Guardian Information (If applicable)</h4>
<table>
    <tr>
        <td className='w-250'><span className='eleHeader'>Last Name:</span>
            <input type='text' id='txtLastName1' name='txtLastName1' className='add-only'/></td>
        <td className='w-250'><span className='eleHeader'>First Name:</span>
            <input type='text' id='txtFirstName1' name='txtFirstName1' className='add-only'/></td>
        <td className='w-250'><span className='eleHeader'>Middle Name:</span>
            <input type='text' id='txtMiddleName1' name='txtMiddleName1' className='add-only'/></td>
    </tr>
</table>
<table>
    <tr>
        <td className='w-375'><span className='eleHeader'>Relationship:</span>
            <input type='text' id='txtRelationship' name='txtRelationship' className='add-only'/></td>
        <td className='w-375'><span className='eleHeader'>Contact Number:</span>
            <input type='text' id='txtContactNumber' name='txtContactNumber' className='add-only'/></td>
    </tr>
</table>
<p className='w-750'>
    <span className='eleHeader'>Client Medical and Allergy Information</span>
    <textarea id='txtClientMedical' name='txtClientMedical' className='add-only'></textarea>
</p>
<h4>Client Orientation</h4>
<p className='w-750'>{`By signing below, you acknowledge receipt of the Client Orientation Handbook and a verbal explanation of all information contained in the handbook by a Right Path Behavioral Health Services staff person.`}</p>

<h4>Consent for Treatment</h4>
<p className='w-750'>{`By signing below, you hereby give consent to Right Path Behavioral Health Services to provide Behavioral/Mental Health services to you or your child/ward. You acknowledge that you have been informed to the scope and purpose of the services and that you understant that you may Right Path Behavioral Health Services staff person has verbally explained the consent form to you and has provided you with a copy of the Client Orientation Handbook including this consent form.`}</p>

<h4>Client Rights</h4>
<p className='w-750'>{`By signing below, you hereby acknowledge that you have been informed of your client rights, understand that you can file a complaint or grievance at any time, are aware of your client rights, and that a Right Path Behavioral Health Services staff person has given you a client rights form and has verbally explained your rights as a client.`}</p>

<h4>Consent for Transportation</h4>
<p className='w-750'>{`By signibng below, you hereby grant permission for Right Path Behavioral Health Services to provide you or your child/ward transportation, you agree to hold Right Path Behavioral Healthcare Services harmless for any accidents/injury that result from the provision of transportation, acknowledge that you are aware of the Right Path Behavioral Health Services transportation polices and that a Right Path employee has verbally explained these policies.`}</p>

<h4>Permission to Seek Emergency Medical Care
</h4>
<p className='w-750'>{`By signing below, you acknowledge and hereny give consent to Right Path Behavioral Health Services to seek emergency medical care for you and/or my child/ware. In the event of an emergency, Right Path Behavioral Health Services will attempt to locate a guardian, an immediate family member (age 18 and over), or legally responsible as quickly as is possible in the emergency/crisis situation. Signing below indicates taht I'm aware of Right Path emergency medical care policies and a Right Path employee has verbally explained these policies.`}</p>

<h4>Confidentiality </h4>
<p className='w-750'>{`By signing below, you acknowledge that you have received and had explained to you the Right to Confidentiality handout. Right Path Behavioral Health Services, a Right Path Behavioral Health Serivices staff person has provided you with a confidentiality form, and a Right Path Behavioral Health Services has fully examined confidentiality, HIPAA, and privacy information:`}</p>

<h4>Client Choice </h4>
<p className='w-750'>{`By signing below, you acknowledge that you have received information regarding the Right Path Behavioral Health Services admission and exclusion criteria, that you understand that you or your child/ward is eligible for services and that eligible clients have the opportunity to choose any Behavioral Health Service Provider to receive services, that you are choosing Right Path Behavioral Health Services for you or your child/ward to receive behavioral health services, that a Right Path Behavioral Health Services staff person has provided you with a verbal explanation of this right.`}</p>

<h4>Notice of Privacy Practices</h4>
<p className='w-750'>{`By signing below, you acknowledge understanding of what private health information (PHI) is, that you are aware of and understand Right Path Behavioral Health Services Privacy Practices and that a Right Path Behavioral Health Services staff person has provided you with a verbal explanation of these policies.`}</p>

<h4>Discharge/Termination Criteria
</h4>
<p className='w-750'>{`By signing below, you acknowledge understanding that you or your child/ward may be discharged from services for numerous reasons such as non-compliance with treatment, not meeting eligibility criteria, due to successfully achieving goals, that you are aware of and understand Right Path Behavioral Health Services discharge policies, and that a Right Path Behavioral Health Services staff person has provided you with a verbal explanation of these policies.`}</p>

<h4>Emergency/Crisis Information</h4>
<p className='w-750'>{`By signing below, you acknowledge taht you are aware of and understand Right Path Behavioral Health Services emergency and crisis policies and that a Right Path staff person has provided you with a verbal explanation of these policies.`}</p>

<h4>Mandated Abuse and Neglect Reporting
</h4>
<p className='w-750'>{`By signing below, you acknowledge that you are aware of and understand Right Path Behavioral Health Services mandated abuse and neglect reporting and that a Right Path Behavioral Health Services staff person has provided you with a verbal explanation of these policies.`}</p>

<table>
                    <tr>
                        <td className='signature w-750'>&nbsp; </td>
                        
                    </tr>
                    <tr>
                        <td className='small w-750'> Signature </td>
                        
                    </tr>
                </table>


                
            </div>
        </form>

    )
}











